import React, { useEffect } from "react";
import { Card, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ReactTooltip from "react-tooltip";
import typesEntreprises from "../../../assets/data/typesEntreprises.json";
import FormalityHeader from "../../../components/header/FormalityHeader";
import { addToCart } from "../../../redux/actions/CartActions";
import "../../styles/flow-form.css";

function OapiBusinessType() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleAddToCart = async (value) => {
    await dispatch(
      addToCart({
        businessType: value,
      })
    );

    navigate(`/oapi-sector-activity`);
  };

  return (
    <div className="legacy-flow">
      <FormalityHeader from={cart.from} />
      <>
        <div className="container my-4">
          <h4 className="text-center  mt-4 mb-4">
            Quel est le <span style={{ color: "#FF5500" }}>type</span> de votre
            entreprise ?
          </h4>

          <Row className="justify-content-center">
            {typesEntreprises.map((type, index) => (
              <Col
                xs={12}
                sm={4}
                md={3}
                lg={3}
                key={index}
                className="mb-4 mx-3"
              >
                <OverlayTrigger
                  placement="bottom"
                  color="#FF5500"
                  overlay={
                    <Tooltip id={`tooltip-${index}`}>
                      {type.description}
                    </Tooltip>
                  }
                >
                  <Card
                    style={{
                      height: "100px",
                      cursor: "pointer",
                      transition: "0.3s",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      borderRadius: "8px",
                      textAlign: "center",
                      border: "2px solid transparent",
                    }}
                    className="p-2"
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow =
                        "0 8px 16px rgba(0, 0, 0, 0.2)";
                      e.currentTarget.style.borderColor = "#FF5500";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow =
                        "0 4px 8px rgba(0, 0, 0, 0.1)";
                      e.currentTarget.style.borderColor = "transparent";
                    }}
                    onClick={() => handleAddToCart(type.name)}
                  >
                    <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                      <Card.Title style={{ fontSize: "1rem", fontWeight: 500 }}>
                        {type.name}
                      </Card.Title>
                    </Card.Body>
                  </Card>
                </OverlayTrigger>
              </Col>
            ))}
          </Row>
        </div>
        <ReactTooltip place="top" type="dark" effect="solid" />
      </>
    </div>
  );
}

export default OapiBusinessType;
